import type { FaireProductEntity } from "../../entity_types/product";

export const p_xjrrg85rkj: FaireProductEntity = {
  token: "p_xjrrg85rkj",
  type: "product",
  name: "ZENNY - Statement Mule Sandal, Frog Closure Detail",
  brandToken: "b_mz3xxxsvnf",
  brandName: "Lemonade Shoes",
  imageUrl: "https://cdn.faire.com/fastly/439348cf0fa467b55afa0256cab02b8e1643557f8d5fe1f9bfd30a0765e2c64e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/99981515b95e579e8b336109d58f0720602d017679f6fc8e25c63ab57e776331.jpeg",
    "https://cdn.faire.com/fastly/97267154462aa5c7a375ff6bbe5470fb7e5805e0a2b011fef7e929a513024dae.jpeg",
    "https://cdn.faire.com/fastly/9435470ca9377828bd5a8edfe8ed998ad6c2508a7aa49b56bc399e9ce4f7b810.jpeg",
    "https://cdn.faire.com/fastly/10f9e7778aa5681b99cd9dc598d8f57a511930a882713ef7344f579fbaf50c37.jpeg"
  ],
  priceDollars: 9.5,
  description: "A modern mule inspired by traditional Chinese silhouettes, featuring a sleek satin finish and decorative knotted frog closures across the upper. The easy slip-on shape gives this statement style a relaxed, wearable feel while intricate details add a playful touch. Available in mauve, green, black, and pink.\nOOTD\nStyle them with loose straight-leg jeans and a fitted tee for an unexpected everyday look, or pair with a mini skirt and oversized blazer for something more dressed up. Finish with a small shoulder bag and simple jewelry to let the detailing stand out.",
  tags: [],
  msrpDollars: 19,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-13T23:39:06.665Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
